import { Table } from '@innovationdepartment/proxima-ui';
import type { BrandListProps } from 'types/brandList';
import BrandListResultsWrapper from './BrandList.ResultsWrapper';

const BrandListFavorites = <Row,>(props: BrandListProps<Row>) => {
  const { favorites, config } = props;

  return (
    <BrandListResultsWrapper>
      <Table data={favorites} config={config} />
    </BrandListResultsWrapper>
  );
};

export default BrandListFavorites;
